import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function View({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12 15.3334C13.8409 15.3334 15.3333 13.841 15.3333 12C15.3333 10.1591 13.8409 8.66669 12 8.66669C10.159 8.66669 8.66663 10.1591 8.66663 12C8.66663 13.841 10.159 15.3334 12 15.3334Z"
        fill={iconColor}
      />
      <Path
        d="M12 4.66669C7.12212 4.66669 2.898 7.52159 0.74108 11.6939C0.641808 11.8859 0.641808 12.1141 0.74108 12.3062C2.898 16.4784 7.12212 19.3334 12 19.3334C16.8778 19.3334 21.1019 16.4785 23.2588 12.3062C23.3581 12.1141 23.3581 11.8859 23.2588 11.6939C21.1019 7.5216 16.8778 4.66669 12 4.66669ZM12 18C7.7823 18 4.08148 15.5997 2.08931 12C4.08148 8.40035 7.7823 6.00002 12 6.00002C16.2176 6.00002 19.9184 8.40036 21.9106 12C19.9184 15.5997 16.2176 18 12 18Z"
        fill={iconColor}
      />
    </Svg>
  );
}
